import React from 'react';

import { useObjectSelector, getObject } from '../redux/hooks'
import { Link } from "react-router-dom";

import Spinner from '../compUtils/Spinner'

import { useDispatch } from 'react-redux'

function MovieThumb(props) {
    const dispatch = useDispatch()

    const objectId = "/api/images/" + props.imageId + "/"
    const imageSelector = useObjectSelector(objectId)
    const image = getObject(objectId, imageSelector, dispatch)

    return (
        image() !== "UNKNOWN" ?
            <Link to={"/movies/" + props.movieId}>
                <img src={image().source} alt={image().name} />
            </Link>
            :
            <Spinner />

    );
}

export default MovieThumb;